const FEATURES = [
  {
    id: 1,
    icon: 'ri-arrow-up-down-line',
    title: '下拉式阅读',
    desc: '独创上下滑动浏览模式，告别传统翻页，阅读一气呵成，沉浸感拉满。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    id: 2,
    icon: 'ri-global-line',
    title: '海量漫画库',
    desc: '收录20000+部韩漫、日漫及国漫，覆盖恋爱、奇幻、热血等全品类题材。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    id: 3,
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '图片智能预加载技术，下一话秒开，追更党再也不用焦急等待缓冲。',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    id: 4,
    icon: 'ri-moon-clear-line',
    title: '夜间模式',
    desc: '一键切换深色主题，深夜追漫不伤眼，给你最舒适的阅读环境。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    id: 5,
    icon: 'ri-bookmark-line',
    title: '智能书签',
    desc: '自动记录阅读进度，多设备无缝同步，随时随地接着看，不怕忘记追到哪。',
    color: 'bg-accent-100 text-accent-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            平台特色
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">为什么选择43423漫画网</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">专为漫画爱好者打造的下拉式阅读平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.id}
              className="group p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-100/80 transition-colors cursor-default"
            >
              <div className={`w-12 h-12 rounded-xl ${feature.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-bold text-foreground-950 text-sm md:text-base mb-2">{feature.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}